import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class SelectStylingModel extends CoreStylingModel {
/**
 * Styling of select trigger by StylingModel
 */
select?: StylingModel;
/**
 * Styling of filter by StylingModel
 */
filter?: StylingModel;
/**
 * Styling of options by StylingModel
 */
options?: StylingModel;
/**
 * Styling of static placeholder by StylingModel
 */
staticPlaceholder?: StylingModel;
/**
 * Styling of dropdown panel by StylingModel
 */
dropdownPanel?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of select trigger by StylingModel
 * @type {?}
 */
SelectStylingModel.prototype.select;
/**
 * Styling of filter by StylingModel
 * @type {?}
 */
SelectStylingModel.prototype.filter;
/**
 * Styling of options by StylingModel
 * @type {?}
 */
SelectStylingModel.prototype.options;
/**
 * Styling of static placeholder by StylingModel
 * @type {?}
 */
SelectStylingModel.prototype.staticPlaceholder;
/**
 * Styling of dropdown panel by StylingModel
 * @type {?}
 */
SelectStylingModel.prototype.dropdownPanel;
}

